import { useCallback } from "react";

import { format } from "date-fns";

import { useCanWriteTasks } from "@/hooks/useActiveRole";
import { useActiveView } from "@/hooks/useActiveView";
import { useHomeNavigation } from "@/hooks/useHomeNavigation";
import { useTasksFilters } from "@/hooks/useTasksFilters";

/**
 * Whether a task can be started from here, and the action that opens its
 * panel. Shared by the home page's button and the mobile nav bar's.
 */
export const useNewTask = () => {
	const { filters } = useTasksFilters();
	const { view: activeView } = useActiveView();
	const { toNewTask } = useHomeNavigation();
	// A view grants nothing: what one may write to is decided on the
	// project (docs/modele.md, phase 6). A VIEWER of the filtered project
	// is not offered the button the API would refuse.
	const canWrite = useCanWriteTasks();

	const create = useCallback(() => {
		const date =
			filters.dateFrom === filters.dateTo
				? new Date(filters.dateFrom ?? new Date())
				: new Date();
		// The project filter, when there is one, travels with the URL.
		toNewTask({ date: format(date, "yyyy-MM-dd") });
	}, [filters.dateFrom, filters.dateTo, toNewTask]);

	return { canCreate: !!activeView && canWrite, create };
};
